import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this.observer = new ResizeObserver(() => this.update())
    this.observer.observe(this.element)
  }

  disconnect () {
    this.observer.disconnect()
  }

  update () {
    const width = this.element.clientWidth

    if (width > 0) {
      this.element.sizes = `${width}px`
    }
  }
}
